import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'market-product-list',
  name: '橱窗商品',
  icon: '橱',
  group: '选品组件',
  description: '读取当前橱窗在售选品规格并渲染商品卡片。',
  defaultProps: {
    title: '精选商品',
    columns: 2,
    limit: 20
}
}
